import {
  EntityIconBase,
  type EntityIconAppearance,
  type EntityIconDensity,
} from './entity-icon-base';
import { Route01Icon } from '@terra/ui-icons';

type IconEntryPointProps = {
  appearance?: EntityIconAppearance;
  density?: EntityIconDensity;
};

export function IconEntryPoint({ appearance, density }: IconEntryPointProps) {
  return (
    <EntityIconBase
      icon={Route01Icon}
      bg="bg.entity.entryPoint"
      color="fg.entity.entryPoint"
      borderColor="border.entity.entryPoint"
      appearance={appearance}
      density={density}
    />
  );
}
